import "./Ilustration2.css"

export function Ilustration2() {
  return (
    <div className="illustration ilu-2">
      <svg
        // width="248"
        // height="248"
        viewBox="0 0 248 248"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="123.861" cy="126.862" r="99.5" fill="#006D68" />
        <path
          d="M123.961 222.993C177.256 222.993 220.461 180.013 220.461 126.993C220.461 124.839 220.39 122.702 220.249 120.583C205.817 98.4002 181.214 80.301 150.651 72.1117C97.7891 57.9474 45.5423 78.3711 27.8627 118.174C27.5968 121.079 27.4609 124.02 27.4609 126.993C27.4609 180.013 70.6655 222.993 123.961 222.993Z"
          fill="#001126"
          fill-opacity="0.3"
        />
        <path
          d="M27.7529 152.615C34.3471 177.225 50.1305 198.367 71.8503 211.685C93.5702 225.004 119.571 229.483 144.496 224.199C169.42 218.916 191.368 204.273 205.816 183.288C220.264 162.303 226.112 136.575 222.154 111.406C218.197 86.2374 204.735 63.5458 184.543 48.0078C164.352 32.4698 138.969 25.2694 113.626 27.8904C88.2837 30.5114 64.9119 42.7542 48.3277 62.0956C31.7435 81.4371 23.2106 106.403 24.4876 131.849"
          stroke="#BAD0A2"
          stroke-width="5"
          stroke-linecap="round"
          className="anim-circle"
        />
        <path
          d="M109.935 119.333C107.594 115.28 89.6872 124.602 86.1765 126.061C81.4247 129.476 71.972 139.983 68.49 144.341L71.9528 175.957C71.9521 175.96 71.9523 175.961 71.9532 175.961L71.9528 175.957C72.0406 175.512 86.8095 139.934 88.2795 137.868C92.8362 134.774 113.249 125.074 109.935 119.333Z"
          fill="#E5EEF9"
        />
        <path
          d="M68.49 144.341C71.972 139.983 81.4247 129.476 86.1765 126.061C89.6872 124.602 107.594 115.28 109.935 119.333C113.249 125.074 92.8362 134.774 88.2795 137.868C86.7987 139.949 71.8233 176.036 71.9532 175.961L68.49 144.341Z"
          stroke="black"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M104.113 109.248C101.772 105.194 83.865 114.516 80.3542 115.975C75.6024 119.391 66.1498 129.898 62.6677 134.255L71.9833 150.39C71.9832 150.392 71.9836 150.393 71.9847 150.392L71.9833 150.39C72.0041 150.13 80.9886 129.846 82.4572 127.782C87.0139 124.688 107.427 114.988 104.113 109.248Z"
          fill="#E5EEF9"
        />
        <path
          d="M62.6677 134.255C66.1498 129.898 75.6024 119.391 80.3542 115.975C83.865 114.516 101.772 105.194 104.113 109.248C107.427 114.988 87.0139 124.688 82.4572 127.782C80.9765 129.863 71.8547 150.467 71.9847 150.392L62.6677 134.255Z"
          stroke="black"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M73.1266 147.715C77.239 146.685 83.4674 150.486 87.0184 153.142L84.809 159.797L73.9068 160.712L73.1266 147.715Z"
          fill="#CCE0F9"
          stroke="black"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M143.719 110.281C143.719 105.6 163.888 104.719 167.658 104.228C173.481 104.81 186.92 109.183 192.115 111.215L204.925 140.331C196.499 145.252 174.063 116.566 171.74 115.505C166.247 115.103 143.719 116.91 143.719 110.281Z"
          fill="#E5EEF9"
          stroke="black"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M143.719 98.6347C143.719 93.954 171.229 91.7433 174.999 91.2516C180.822 91.8339 186.92 97.5367 192.115 99.5692L193.499 117.749C193.5 117.751 193.501 117.752 193.499 117.752L193.499 117.749C193.336 117.546 174.044 104.912 171.74 103.858C166.247 103.457 143.719 105.264 143.719 98.6347Z"
          fill="#E5EEF9"
        />
        <path
          d="M192.115 99.5692C186.92 97.5367 180.822 91.8339 174.999 91.2516C171.229 91.7433 143.719 93.954 143.719 98.6347C143.719 105.264 166.247 103.457 171.74 103.858C174.063 104.92 193.649 117.752 193.499 117.752L192.115 99.5692Z"
          stroke="black"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M195 113.752C195.467 124.752 187.531 130.41 183 132.761H185.71L195.609 128.102L195 113.752Z"
          fill="black"
          stroke="black"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M52.1003 191.736C51.3643 185.861 50.3395 181.692 49.067 176.516C48.8163 175.497 48.5561 174.438 48.2865 173.319C46.9147 167.627 45.5253 159.819 45.9749 156.373C47.2865 146.319 50.4785 125.512 54.2865 118.319L70.9995 105.493L74.4995 120.493C74.4995 120.493 68.7864 128.819 66.2864 131.819C66.5888 132.726 67.1654 133.588 67.9057 134.694C69.6139 137.245 72.1936 141.099 74.2865 149.819C81.2865 154.319 84.2865 159.819 84.2865 159.819L94.7864 185.819L87.7864 197.319L83.7627 215.203C71.6511 209.617 60.8883 201.585 52.1003 191.736Z"
          fill="white"
        />
        <path
          d="M84.2871 159.819C84.2871 159.819 79.287 156.373 74.2871 149.819C71.2871 137.319 67.287 134.819 66.287 131.819C68.787 128.819 84.2871 105.819 84.2871 105.819L79.287 99.3194L54.2871 118.319C50.479 125.512 47.2871 146.319 45.9754 156.373C44.7048 166.113 47.1988 176.845 49.6147 187.493"
          stroke="black"
          stroke-width="3"
          stroke-linecap="round"
        />
        <rect
          x="51.0059"
          y="19.8477"
          width="105"
          height="178"
          rx="15"
          transform="rotate(-13.13 51.0059 19.8477)"
          fill="#001126"
        />
        <circle
          cx="138.003"
          cy="163.239"
          r="7"
          transform="rotate(-13.13 138.003 163.239)"
          fill="#CCE0F9"
        />
        <circle
          cx="97.1669"
          cy="137.851"
          r="7"
          transform="rotate(-13.13 97.1669 137.851)"
          fill="#CCE0F9"
        />
        <circle
          cx="91.7157"
          cy="114.479"
          r="7"
          transform="rotate(-13.13 91.7157 114.479)"
          fill="#CCE0F9"
        />
        <circle
          cx="86.2645"
          cy="91.1063"
          r="7"
          transform="rotate(-13.13 86.2645 91.1063)"
          fill="#CCE0F9"
        />
        <circle
          cx="80.8114"
          cy="67.7337"
          r="7"
          transform="rotate(-13.13 80.8114 67.7337)"
          fill="#CCE0F9"
        />
        <circle
          cx="75.3603"
          cy="44.3611"
          r="7"
          transform="rotate(-13.13 75.3603 44.3611)"
          fill="#CCE0F9"
        />
        <line
          x1="107.767"
          y1="134.866"
          x2="169.12"
          y2="120.555"
          stroke="#F9FAFA"
          stroke-width="15"
          className="line-anim a5"
        />
        <line
          x1="102.314"
          y1="111.493"
          x2="163.667"
          y2="97.182"
          stroke="#D6E3C7"
          stroke-width="15"
          className="line-anim a4"
        />
        <line
          x1="96.8627"
          y1="88.1206"
          x2="158.216"
          y2="73.8095"
          stroke="#707D61"
          stroke-width="15"
          className="line-anim a3"
        />
        <line
          x1="91.4115"
          y1="64.748"
          x2="152.765"
          y2="50.4368"
          stroke="#4BC9FF"
          stroke-width="15"
          className="line-anim a2"
        />
        <line
          x1="86.1869"
          y1="42.3493"
          x2="147.54"
          y2="28.0381"
          stroke="#4089A9"
          stroke-width="15"
          className="line-anim a1"
        />
        <g opacity="0.4">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M74.4788 113.976C73.7515 113.577 73.533 112.695 73.9907 112.005L146.585 2.64724C147.043 1.95777 148.004 1.72198 148.731 2.12057C149.458 2.51916 149.677 3.4012 149.219 4.09066L76.6242 113.449C76.1666 114.138 75.206 114.374 74.4788 113.976Z"
            fill="white"
            fill-opacity="0.2"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M78.7965 124.45C78.0693 124.051 77.8507 123.169 78.3084 122.48L150.903 13.1214C151.361 12.432 152.321 12.1962 153.049 12.5947C153.776 12.9933 153.994 13.8754 153.537 14.5648L80.942 123.923C80.4843 124.613 79.5237 124.848 78.7965 124.45Z"
            fill="white"
            fill-opacity="0.2"
          />
        </g>
        <path
          d="M203.817 180.908C214.322 165.539 220.461 146.98 220.461 126.993C220.461 125.159 220.41 123.337 220.308 121.528C220.007 119.073 219.732 116.607 219.484 114.127C219.104 110.327 211.637 105.392 208.283 105.392C206.127 98.5233 203.758 91.8896 200.456 85.2851C200.296 84.9659 200.152 84.6663 200.015 84.3816C199.406 83.1121 198.939 82.1403 197.86 81.0609C193.132 76.3328 164.856 58.9803 162.229 64.6306C160.089 71.1776 179.887 85.5938 187.457 89.0876C190.939 98.4891 197.86 119.252 186 132.252C179.255 127.867 170.099 123.853 162.229 122.206C156.354 120.977 136.092 122.664 149.025 129.849C149.831 130.297 150.627 130.734 151.413 131.166C156.051 133.715 160.362 136.084 164.615 139.425C168.636 142.585 172.901 148.703 175.5 153.252C177.761 157.208 182.526 159.974 187.171 162.671C190.256 164.462 193.289 166.223 195.5 168.282C198.981 171.522 201.749 176.255 203.817 180.908Z"
          fill="white"
        />
        <path
          d="M220.209 134.006C220.377 131.69 220.462 129.352 220.462 126.993C220.462 121.209 219.948 115.544 218.962 110.042C218.47 109.575 217.941 109.179 217.436 108.824C217.18 108.643 215.772 107.704 214.184 106.695C212.901 105.88 211.421 104.969 210.314 104.376C208.806 100.129 206.826 95.274 204.715 90.8734C203.216 87.7494 201.634 84.8188 200.09 82.4832C198.595 80.2212 196.98 78.2711 195.352 77.4124C190.392 74.7962 186.374 72.4725 181.781 69.8166L181.781 69.8161C179 68.208 176.009 66.4782 172.471 64.4879C170.997 63.6588 168.434 62.2335 166.073 61.6576C164.904 61.3724 163.549 61.2328 162.337 61.6874C160.986 62.1943 160.102 63.3234 159.783 64.9188C159.374 66.9648 160.224 69.1093 161.547 71.1044C162.9 73.144 164.928 75.2997 167.362 77.4749C172.136 81.741 178.689 86.2703 185.457 90.3674C189.601 101.207 190.939 113.844 188.605 125.103C187.886 126.036 187.392 126.782 187.015 127.383C186.853 127.64 186.727 127.848 186.621 128.021C186.432 128.332 186.308 128.535 186.168 128.722C186.018 128.923 185.917 129.009 185.735 129.1C185.507 129.214 185.133 129.341 184.414 129.506C181.531 128.488 179.027 127.249 176.449 125.974L176.173 125.837C172.266 123.905 168.177 121.918 162.537 120.738C159.525 120.107 155.682 119.481 152.459 119.481C152.055 119.481 150.75 119.563 149.333 119.854C148.618 120 147.834 120.208 147.102 120.504C146.387 120.794 145.619 121.21 145.031 121.824C144.042 122.856 143.393 123.925 143.225 125.055C143.048 126.241 143.433 127.251 144.027 128.047C144.593 128.806 145.37 129.404 146.098 129.881C146.728 130.293 147.413 130.672 148.011 131.002C148.109 131.056 148.204 131.109 148.297 131.16C149.114 131.615 149.917 132.056 150.707 132.49C155.347 135.04 159.54 137.345 163.689 140.605C167.53 143.623 171.98 149.082 174.502 153.496C175.563 155.352 177.216 157.106 179.094 158.746C180.983 160.396 183.176 161.994 185.383 163.52C186.554 164.33 187.72 165.114 188.851 165.874L188.852 165.875C192.071 168.04 195.008 170.014 196.979 171.849C199.872 174.543 201.856 178.093 203.247 181.733C203.936 180.749 204.606 179.751 205.257 178.739C203.804 175.465 201.809 172.247 199.023 169.654C196.863 167.642 193.622 165.464 190.334 163.254C189.245 162.522 188.151 161.787 187.089 161.053C184.91 159.546 182.828 158.024 181.068 156.487C179.297 154.94 177.927 153.443 177.107 152.007C174.431 147.324 169.743 141.546 165.542 138.246C161.185 134.822 156.756 132.389 152.12 129.843L152.112 129.838C151.332 129.41 150.546 128.978 149.754 128.538C149.652 128.481 149.551 128.426 149.451 128.37L149.446 128.368C148.843 128.034 148.269 127.717 147.742 127.371C147.121 126.965 146.687 126.595 146.431 126.253C146.204 125.948 146.158 125.726 146.192 125.498C146.234 125.215 146.439 124.69 147.197 123.899C147.373 123.716 147.705 123.497 148.229 123.285C148.736 123.079 149.33 122.916 149.936 122.792C151.159 122.541 152.262 122.481 152.459 122.481C155.369 122.481 158.97 123.056 161.922 123.674C167.162 124.771 170.959 126.606 174.843 128.526L175.184 128.695C178.963 130.565 182.881 132.505 188.166 133.714C188.974 133.899 189.778 133.394 189.963 132.586C190.148 131.779 189.643 130.974 188.835 130.789C188.7 130.758 188.566 130.727 188.433 130.695C188.48 130.637 188.527 130.578 188.572 130.517C188.798 130.215 189.036 129.825 189.275 129.433C189.369 129.279 189.463 129.126 189.556 128.977C189.925 128.389 190.419 127.645 191.179 126.68L191.395 126.406L191.468 126.066C194.069 113.926 192.589 100.342 188.068 88.8009L187.882 88.3258L187.445 88.0627C180.597 83.9421 174.04 79.4193 169.361 75.2379C167.017 73.1432 165.199 71.1829 164.047 69.4461C162.866 67.6648 162.552 66.3726 162.725 65.5071C162.874 64.7628 163.158 64.5833 163.39 64.4963C163.761 64.3571 164.404 64.3384 165.362 64.5721C167.256 65.0343 169.466 66.2399 171 67.1026C174.464 69.0513 177.431 70.767 180.208 72.3723C184.845 75.0537 188.95 77.4274 193.952 80.066C194.841 80.5349 196.099 81.8855 197.588 84.1377C199.028 86.3163 200.543 89.1135 202.01 92.1711C204.085 96.4972 206.031 101.274 207.503 105.424C207.51 105.742 207.618 106.051 207.811 106.303C208.291 107.691 208.713 108.997 209.063 110.178C209.298 110.972 210.133 111.425 210.927 111.19C211.721 110.955 212.174 110.12 211.939 109.326C211.879 109.124 211.817 108.918 211.754 108.71C212.028 108.881 212.303 109.054 212.575 109.227C214.151 110.228 215.512 111.138 215.71 111.277C217.134 112.28 217.869 113.05 217.992 114.276C218.31 117.459 218.625 120.166 218.944 122.912L218.944 122.914C219.205 125.158 219.468 127.429 219.74 130.006C219.885 131.382 220.039 132.706 220.209 134.006Z"
          fill="black"
        />
        <path
          d="M88.4872 195.202L88.6313 194.876C91.6916 187.954 97.7914 181.879 98.6563 174.345C99.2539 169.14 103.922 162.504 106.374 158.016C109.406 152.465 113.036 148.105 116.932 143.073C118.856 140.589 121.504 137.479 116.856 135.504C114.823 134.64 110.836 136.038 110.283 136.274C107.465 137.482 104.281 139.501 101.785 141.249C97.5464 144.219 94.651 147.332 91.225 151.071C89.2918 153.181 86.9177 155.355 85.3309 157.701C84.4112 159.061 82.8559 161.534 81.5919 162.443L75.787 180.32L83.4909 213.454C82.4372 208.886 84.3249 204.617 88.4872 195.202Z"
          fill="white"
        />
        <path
          d="M81.5919 162.443C82.8559 161.534 84.4112 159.061 85.3309 157.701C86.9177 155.355 89.2918 153.181 91.225 151.071C94.651 147.332 97.5464 144.219 101.785 141.249C104.281 139.501 107.465 137.482 110.283 136.274C110.836 136.038 114.823 134.64 116.856 135.504C121.504 137.479 118.856 140.589 116.932 143.073C113.036 148.105 109.406 152.465 106.374 158.016C103.922 162.504 99.2539 169.14 98.6563 174.345C97.7914 181.879 91.6916 187.954 88.6313 194.876C86.2293 200.31 84.6164 207.721 83.8569 213.993"
          stroke="black"
          stroke-width="3"
          stroke-linecap="round"
        />
      </svg>
    </div>
  )
}
